import React from "react";
import "../App.css";
import "./cardImg.css";
import "./countdown.css";
import "./borderAni.css";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";

const Profile = () => {
  const { walletAddress, userinfo } = useSelector((state) => state.wallet);

  const handleCopy = (val) => {
    const inputval = val || document.getElementById("referralLink").value;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(inputval).then(() => {
        // setCopied(true);
        // setTimeout(() => setCopied(false), 2000); // Reset copied message after 2 seconds
        toast.success("copied successfuly!");
      });
    } else {
      alert("Clipboard API is not supported on your browser.");
    }
  };

  return (
    <>
      <div className="row mb-3">
        <div class="col-xl-8 m-auto">
          <div class="card text-white mb-2 box borderAni mt-20">
            <div class="card-body">
              <div class="text-center">
                <img
                  src={require("../assets/9187604.png")}
                  alt="Profile Photo"
                  class="img-fluid rounded-circle mb-2"
                  style={{ width: "100px", height: "100px" }}
                />
              </div>
              <h5 class="card-title text-white">ID Number : {userinfo?.id}</h5>

              <h6>
                <strong>Wallet Address:</strong>{" "}
                <span class="text-white">
                  {walletAddress?.slice(0, 6)}...
                  {walletAddress?.slice(-6)}
                  <span
                    onClick={() => handleCopy(walletAddress)}
                    className=" mx-2"
                  >
                    <i
                      class="fa fa-copy"
                      style={{ fontSize: "15px", color: "#5D87FF" }}
                    ></i>
                  </span>
                </span>
              </h6>
              <h6>
                <strong>Referrer Wallet:</strong>{" "}
                <span class="text-white">
                  {userinfo?.referrer?.slice(0, 6)}...
                  {userinfo?.referrer?.slice(-6)}
                  <span
                    onClick={() => handleCopy(userinfo?.referrer)}
                    className=" mx-2"
                  >
                    <i
                      class="fa fa-copy"
                      style={{ fontSize: "15px", color: "#5D87FF" }}
                    ></i>
                  </span>
                </span>
              </h6>
              <h6>
                <strong>Join Date: </strong>{" "}
                {new Date(userinfo?.timestamp*1000).toLocaleString()}
              </h6>
              <div className=" mt-20">
                {/* <div class="mb-3">
                  <label htmlFor="username" class="form-label">
                    Name *
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="username"
                    name="username"
                    value={userinfo?.name || ""}
                    readonly
                  />
                </div>
                <div class="mb-3">
                  <label htmlFor="useremail" class="form-label">
                    Email *
                  </label>

                  <input
                    type="text"
                    class="form-control"
                    id="useremail"
                    name="useremail"
                    value={userinfo?.email || ""}
                    readonly
                  />
                </div>
                <div class="mb-3">
                  <label htmlFor="usermobile" class="form-label">
                    Mobile (optional)
                  </label>

                  <input
                    type="text"
                    class="form-control"
                    id="usermobile"
                    name="usermobile"
                    value={userinfo?.mobile || ""}
                    readonly
                  />
                </div> */}
                <div class="mb-3">
                  <label htmlFor="exampleInputEmail1" class="form-label">
                    Wallet Address *
                  </label>

                  <input
                    type="text"
                    class="form-control"
                    id="referraladdress"
                    name="referraladdress"
                    value={walletAddress}
                    readonly
                  />
                </div>
                <div class="mb-3">
                  <label htmlFor="exampleInputEmail1" class="form-label">
                    Referral Id
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="referralId"
                    name="referralId"
                    value={userinfo?.user_id || "Your Sponsor ID"}
                    readonly
                  />
                </div>
                <div class="mb-3">
                  <label htmlFor="exampleInputEmail1" class="form-label">
                    Referral Address *
                  </label>

                  <input
                    type="text"
                    class="form-control"
                    id="referraladdress"
                    name="referraladdress"
                    value={userinfo?.referrer}
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
